module.exports = __webpack_public_path__ + "static/media/faq-ambassador-social.77211780.jpg";